import { render, staticRenderFns } from "./CapturePicture.vue?vue&type=template&id=f379f37e&"
import script from "./CapturePicture.vue?vue&type=script&lang=js&"
export * from "./CapturePicture.vue?vue&type=script&lang=js&"
import style0 from "./CapturePicture.vue?vue&type=style&index=0&id=f379f37e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports